import {
  useCallback, useContext,
} from 'react';
import api from '../../../api/req';
import meta from '../../../meta';
import { CiatAppContext } from '../../../providers';

const useReadMessage = () => {
  const { auth } = useContext(CiatAppContext);

  const changeRead = useCallback(async (id) => {
    const r = await api.post(`${meta.app.email.backendURL}`, auth, { message_id: id });
    if (!r.ok && r.status !== 400) {
      throw new Error(`${r.status} ${r.statusText}`);
    }
  }, [auth]);

  return {
    changeRead,
  };
};

export default useReadMessage;
